/**
 * Remaining time until `endTimeIso`, formatted as zero-padded `HH:MM:SS` for
 * the lobby widget's countdown badge (Figma: Widget). Hours are not capped at
 * 24 — a 30-hour window reads `30:00:00`.
 *
 * Returns `null` when there is no end time, the value is unparseable, or the
 * deadline has already passed (the caller hides the badge / falls back).
 */
export function formatHms(endTimeIso: string | null | undefined, nowMs: number): string | null {
  if (!endTimeIso) return null;
  const end = Date.parse(endTimeIso);
  if (Number.isNaN(end)) return null;

  const remainingMs = end - nowMs;
  if (remainingMs <= 0) return null;

  const totalSec = Math.floor(remainingMs / 1000);
  const hours = Math.floor(totalSec / 3_600);
  const mins = Math.floor((totalSec % 3_600) / 60);
  const secs = totalSec % 60;
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${pad(hours)}:${pad(mins)}:${pad(secs)}`;
}
